import carousel1 from "../assets/img/c1.png";
import carousel2 from "../assets/img/c2.png";
import carousel3 from "../assets/img/c3.png";

import perfume1 from "../assets/img/box/CRIMSON_OAK.webp";
import perfume2 from "../assets/img/box/OCEAN_BAY.webp";
import perfume3 from "../assets/img/box/SWEET_SMOKE.webp";

import ImageCarouselLaptop from "../assets/img/ImageCarsoulLaptop.webp";
import ImageCarouselMobile from "../assets/img/ImageCarsoulMobile.webp";
import ImageCarouselTablet from "../assets/img/ImageCarsoulTablet.webp";

import brand_name_logo from "../assets/logo-text.png";

export const IMAGE_CAROUSEL = {
  laptop: ImageCarouselLaptop,
  mobile: ImageCarouselMobile,
  tablet: ImageCarouselTablet,
};

export const ENV = process.env.REACT_APP_ENV;
const BASEURL = process.env.REACT_APP_URL;
export const URL = BASEURL + "/api";

export const BRAND_IMAGE_URL = `${BASEURL}/uploads/brand/`;
export const CATEGORY_IMAGE_URL = `${BASEURL}/uploads/category/`;
export const PRODUCT_IMAGE_URL = `${BASEURL}/uploads/product/`;

export const PIXEL_ID = process.env.REACT_APP_PIXEL_ID;
export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME ?? "KRISTIVE";

export const BRAND_NAME_LOGO = brand_name_logo;

// RAZORPAY
export const KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;

// filter pricing
export const filterPricing = [
  { value: 500, label: "Under ₹500" },
  { value: 1000, label: "₹500 - ₹1000" },
  { value: 1500, label: "₹1000 - ₹1500" },
  { value: 2000, label: "₹1500 - ₹2000" },
  { value: 5000, label: "Over ₹2000" },
];

// Product Colors
export const ProductColors = [
  "Red",
  "Blue",
  "Cyan",
  "Green",
  "Yellow",
  "Violet",
  "Black",
  "White",
];

// Product Sizes
export const ProductSizes = ["Small", "Medium", "Large", "One Size"];

// Sorting
export const SortOptions = [
  // "Recommended",
  "What's New",
  "Price: High to Low",
  "Price: Low to High",
  // "Customer Rating",
];

// Home Carousel
export const carouselDetails = [
  {
    title: "Elegant Glamour",
    subtitle:
      "A stunning collection of fine jewelry designed to elevate your style—whether for everyday elegance or special occasions.",
    image: perfume1,
  },
  {
    title: "Timeless Craftsmanship",
    subtitle:
      "Discover our exquisite range of rings, necklaces, bracelets, and bags, all meticulously crafted for lasting beauty.",
    image: perfume2,
  },
  {
    title: "Perfect for Every Occasion",
    subtitle:
      "From luxurious statement pieces for women to subtle, sophisticated designs for men, our collection has something for everyone.",
    image: perfume3,
  },
];

export const productBox = [
  {
    title: "Bold & Woody",
    subtitle:
      "A bold and woody fragrance with rich, earthy undertones and a powerful, masculine depth.",
    image: perfume1,
    textColor: "#4B1E1E",
    descriptionColor: "#5C3B3B",
  },
  {
    title: "Refreshed and Moody",
    subtitle:
      "A refreshed and citrus fragrance bursting with zesty brightness and invigorating energy.",
    image: perfume2,
    textColor: "#123C51",
    descriptionColor: "#264653",
  },
  {
    title: "Fruity and Sweet",
    subtitle:
      "A fruity and sweet fragrance that delights the senses with juicy notes and a playful, sugary warmth.",
    image: perfume3,
    textColor: "#1D1D1B",
    descriptionColor: "#3B3B3B",
  },
];

// FAQs
export const FAQs_Data = [
  // {
  //   id: "topQueries",
  //   href: "#topQueries",
  //   title: "Top Queries",
  //   questions: [
  //     {
  //       id: 1,
  //       question:
  //         "How will I detect fraudulent emails/calls seeking sensitive personal and confidential information?",
  //       answer: (
  //         <div>
  //           If you receive an e-mail, a call from a person/association claiming
  //           to be from {BRAND_NAME} seeking sensitive confidential information
  //           like debit/credit card PIN, net-banking or mobile banking password,
  //           we request you to never provide such confidential and personal data.
  //           We at {BRAND_NAME} or our affiliate logistics partner never ask for
  //           such confidential and personal data. If you have already revealed
  //           such information, report it immediately to an appropriate law
  //           enforcement agency.
  //         </div>
  //       ),
  //     },
  //     {
  //       id: 2,
  //       question: "How do I cancel the order, I have placed?",
  //       answer:
  //         "Order can't cancel.",
  //     },
  //     // {
  //     //   id: 2,
  //     //   question: "How do I cancel the order, I have placed?",
  //     //   answer:
  //     //     "Order can't cancel. Note: If item has delivered and not like item then you want to return item.",
  //     // },
  //     // {
  //     //   id: 3,
  //     //   question: "How do I create a Return Request?",
  //     //   answer: (
  //     //     <div>
  //     //       <p>You can create a Return in three simple steps</p>
  //     //       <div style={{ marginLeft: "10px", marginTop: "10px" }}>
  //     //         <li>Tap on MyOrders </li>
  //     //         <li>Choose the item to be Returned</li>
  //     //         <li>Enter details requested and create a return request</li>
  //     //       </div>
  //     //       <p>Note: If order amount was paid online.</p>
  //     //     </div>
  //     //   ),
  //     // },
  //     // {
  //     //   id: 4,
  //     //   question:
  //     //     "I have created a Return request. When will the product be picked up?",
  //     //   answer: "The product will be picked anywhere between 4 – 7 days.",
  //     // },
  //     // {
  //     //   id: 5,
  //     //   question:
  //     //     "I have created a Return request. When will I get the refund?",
  //     //   answer:
  //     //     "Refund will be initiated upon successful pickup as per the Returns Policy. The refund amount is expected to reflect in the customer account within 7 days.",
  //     // },
  //     // {
  //     //   id: 6,
  //     //   question: "Where should I self-ship the Returns?",
  //     //   answer: "No.",
  //     // },
  //   ],
  // },
  {
    id: "TnCQueries",
    href: "#TnCQueries",
    title: "Terms and Condition",
    questions: [
      {
        id: 1,
        question:
          "How will I detect fraudulent emails/calls seeking sensitive personal and confidential information?",
        answer: (
          <div>
            If you receive an e-mail, a call from a person/association claiming
            to be from {BRAND_NAME} seeking sensitive confidential information
            like debit/credit card PIN, net-banking or mobile banking password,
            we request you to never provide such confidential and personal data.
            We at {BRAND_NAME} or our affiliate logistics partner never ask for
            such confidential and personal data. If you have already revealed
            such information, report it immediately to an appropriate law
            enforcement agency.
          </div>
        ),
      },
    ],
  },
  {
    id: "shipping",
    href: "#shipping",
    title: "Shipping, Order Tracking & Delivery",
    questions: [
      {
        id: 1,
        question: "How do I check the status of my order?",
        answer:
          "Please tap on “My Orders” section under main menu to check your order status.",
      },
      {
        id: 2,
        question: `How are orders placed on ${BRAND_NAME} delivered to me?`,
        answer: (
          <div>
            All orders placed on {BRAND_NAME} are dispatched through courier.
            {/* partners such as (Blue Dart, Delivery -- delivery courier name) Etc. */}
          </div>
        ),
      },
      {
        id: 3,
        question: `Does ${BRAND_NAME} deliver products outside India?`,
        answer: (
          <div>
            No. At this point, {BRAND_NAME} delivers products only within India.
          </div>
        ),
      },
      {
        id: 4,
        question: "How can I get my order delivered faster?",
        answer:
          "Sorry, currently we do not have any service available to expedite the order delivery. Because our products are handmade and when customer is ordering at a time we will create a product and delivery to customer. In future, if we are offering such service, you will receive a communication from our end.",
      },
    ],
  },
  {
    id: "RnRQueries",
    href: "#RnRQueries",
    title: "Returns & Refunds",
    questions: [
      {
        id: 1,
        question: `What is ${BRAND_NAME} Return Policy?`,
        answer: (
          <div>
            At {BRAND_NAME}, we do not accept returns or offer refunds on any
            products once they have been purchased. Please review your order
            carefully before confirming your purchase to ensure it meets your
            needs. If you have any concerns about your order, feel free to
            contact us.
          </div>
        ),
      },
    ],
    // questions: [
    //   {
    //     id: 1,
    //     question: `What is ${BRAND_NAME} Return Policy? How does it work?`,
    //     answer: (
    //       <div>
    //         {BRAND_NAME}'s returns policy gives you an option to return items
    //         purchased on {BRAND_NAME} for any reason within the specified return
    //         period (check product details page for the same). Feel free to try
    //         on a product but all we ask is that the product remains unused and
    //         is preserved in its original condition along with the tags and
    //         packaging. In case a Seal Tag is received with the item, ensure that
    //         it remains attached & intact with the product to avoid any hassles
    //         in the event of a return. There are one ways to return the product
    //         to us: Pick up:
    //         <li style={{ padding: "10px 15px" }}>
    //           In most locations, we offer a free pick up service. You will see a
    //           pickup option when you submit a return request.
    //         </li>
    //         During Pick Up, our delivery agent may do a quality check on the
    //         return. For a successful pick up, we will initiate a doorstep refund
    //         for the return amount into the refund mode selected at the time of
    //         initiating the return request.
    //       </div>
    //     ),
    //   },
    //   {
    //     id: 2,
    //     question: `To return a product to ${BRAND_NAME}, please follow these steps:`,
    //     answer: (
    //       <div>
    //         You can return products purchased from {BRAND_NAME} within the
    //         specified return period(check product details page for the same),
    //         except for our products which can only be returned for limited
    //         number of days.
    //         <p style={{ padding: "10px 15px" }}>
    //           1. Create a 'Return Request' under “My Orders” section of Website.
    //           Follow the screens that come up after tapping on the 'Return'
    //           button. Please make a note of the Return ID that we generate at
    //           the end of the process. Keep the item ready for pick up or ship it
    //           to us basis on the return mode.
    //         </p>
    //         <b>Pick-up:</b> If you select to schedule a pick-up, please place
    //         the product in a packet and the product must be unused, unwashed and
    //         all the tags are intact.Keep the packet ready and open to expedite
    //         the return pickup. Our staff may initially examine the product at
    //         the time of pickup and a further quality check of the product will
    //         be conducted at our Returns Desk.
    //       </div>
    //     ),
    //   },
    //   {
    //     id: 3,
    //     question: "What is Instant Refunds?",
    //     answer: (
    //       <div>
    //         Upon successful pickup of the return product at your doorstep,
    //         {BRAND_NAME} will instantly initiate the refund to your source
    //         account or chosen method of refund. Instant Refunds is not available
    //         in a few select pin codes and for all self ship returns.
    //       </div>
    //     ),
    //   },
    //   {
    //     id: 4,
    //     question:
    //       "Why have I not received my Refund despite Instant Refunds policy?",
    //     answer:
    //       "For refunds taken into source accounts via UPI & Wallet, your refund will reflect instantly(48hrs in case of delay).For refunds taken to source accounts (that is Credit Card, Debit Card and Net Banking), your refund may take 7-10 days to reflect in your account depending upon your bank partner.",
    //   },
    //   {
    //     id: 5,
    //     question:
    //       "How long would it take me to receive the refund of the returned product?",
    //     answer:
    //       "Refund will be initiated upon successful pickup as per the Returns Policy. The refund amount is expected to reflect in the customer account within 7 days.",
    //   },
    //   {
    //     id: 6,
    //     question: "How do I return multiple products from a single order?",
    //     answer:
    //       "If you are returning multiple products from a single order then, you will receive a separate Return ID via e-mail for each item. When our courier person will pickup the products from the pickup address(Delivery address).",
    //   },
    //   {
    //     id: 7,
    //     question: `Can I Self-Ship the product to ${BRAND_NAME}?`,
    //     answer: (
    //       <div>
    //         No, {BRAND_NAME} has no self-ship the product. In future, if we are
    //         offering such service, you will receive a communication from our
    //         end.
    //       </div>
    //     ),
    //   },
    //   {
    //     id: 8,
    //     question: "Why has my return request been declined?",
    //     answer: (
    //       <div>
    //         This may have happened, if the item you returned is used, damaged or
    //         original tags are missing. In the event that the return request is
    //         declined, the user shall not be eligible for a refund, and
    //         {BRAND_NAME} assumes no liability in this regard. For more details,
    //         please call our customer care.
    //       </div>
    //     ),
    //   },
    // ],
  },
  {
    id: "signUpSingIn",
    href: "#signUpSingIn",
    title: "Sign Up & Sign In",
    questions: [
      {
        id: 1,
        question: `How do I create an account on ${BRAND_NAME}?`,
        answer: (
          <div>
            You can create your account on {BRAND_NAME} by fill up the form and
            Click on 'Sign Up'. And Verify your email to create your
            {BRAND_NAME} account.
          </div>
        ),
      },
      {
        id: 2,
        question: `How do I sign in on ${BRAND_NAME}?`,
        answer: "You can use your email,password and OTP for easy sign in.",
      },
      {
        id: 3,
        question: `How can i change my mobile number that I use to login on ${BRAND_NAME}?`,
        answer:
          "You can log in to your account and change it from your Profile > Edit Profile.",
      },
      {
        id: 4,
        question: "Why is my account locked?",
        answer: (
          <div>
            {BRAND_NAME} locks accounts for a specified time period or
            permanently in case there are too many failed login attempts to your
            account. This is for the security of your account. You should be
            able to gain access back to your account by resetting your password
            or call customer care for further help.
          </div>
        ),
      },
    ],
  },
  {
    id: "paymentQueries",
    href: "#paymentQueries",
    title: "Payments",
    questions: [
      {
        id: 1,
        question: `How can I pay for my order at ${BRAND_NAME}?`,
        answer: (
          <div>
            <p>We support the following payment options at {BRAND_NAME}:</p>
            <ol>
              <li>Cash On Delivery</li>
              <li>Credit Card</li>
              <li>Debit Card</li>
              <li>Net banking</li>
              <li>UPI</li>
            </ol>
          </div>
        ),
      },
      {
        id: 2,
        question: "How does the COD (Cash on Delivery) payment option work?",
        answer: (
          <div>
            {BRAND_NAME}'s Cash on Delivery option allows you to pay order value
            at the time of delivery for all orders.
          </div>
        ),
      },
      // {
      //   id: 3,
      //   question: "What should I do if my payment fails?",
      //   answer:
      //     "Please retry making the payment after ensuring that the information entered is accurate, including all account details, billing addresses and passwords. If your payment still fails, you can use the Cash on Delivery (COD) payment option, if available on the payment page to place your order. If your payment is debited from your account after a payment failure, it will be credited back within 7-10 days, after we receive a confirmation from the bank.",
      // },
    ],
  },
];

export const PRIVACY_POLICY_DATA = [
  {
    id: 1,
    title: "Introduction",
    content: (
      <>
        <p>
          We value the trust you place in us and recognize the importance of
          secure transactions and information privacy. This Privacy Policy
          describes how {BRAND_NAME} Internet Private Limited and its affiliates
          (<b>“{BRAND_NAME}”</b>, also identified by <b>“we”</b> or <b>“us”</b>{" "}
          or
          <b>“our”</b>) collect, use, share or otherwise process your personal
          information through {BRAND_NAME} website www.{BRAND_NAME}.com, its
          mobile application, and m-site (hereinafter referred to as the{" "}
          <b>“Platform”</b>).
        </p>
        <p>
          While you can browse sections of the Platform without the need of
          sharing any information with us, however, please note we do not offer
          any product or service under this Platform outside India.. By visiting
          this Platform, providing your information or availing out
          product/service, you expressly agree to be bound by the terms and
          conditions of this Privacy Policy, the Terms of Use and the applicable
          service/product terms and conditions, and agree to be governed by the
          laws of India including but not limited to the laws applicable to data
          protection and privacy. If you do not agree please do not use or
          access our Platform.
        </p>
      </>
    ),
  },
  {
    id: 2,
    title: "What information do we collect?",
    content: (
      <>
        <div>
          We learn, collect, and store your personal information (that we
          consider necessary) when you use our Platform. We use this information
          to provide you with a safe, efficient, smooth, and customized
          experience, which includes, without limitation, displaying content
          such as recommended products that might interest you and communicating
          with you about your orders, new products, and latest promotional
          offers. This allows us to provide specific services and features that
          most likely meet your needs, customize our Platform to make your
          experience safer and easier, and enable third parties to carry out
          technical, logistical, and other functions on our behalf. <br />
          <b>Here are the types of information we gather:</b>
        </div>
        <div>
          <b>1) Information you provide us</b>
          <p>
            We receive and store the information you explicitly provide to us.
            This includes personal information such as your user name along with
            your password, your name, address, telephone number, e-mail address
            and other contact information, date of birth, gender and any other
            information that you provide during your time on the Platform. You
            may choose not to provide certain information, but this could
            prevent you from taking full advantage of our Platform’s various
            features.
          </p>
        </div>
        <div>
          <b>2) Information collected automatically</b>
          <p>
            Whenever you interact with our Platform, we automatically receive,
            record, and analyze information from your browser or device, which
            includes, without limitation, your IP address, geolocation data,
            device identification, “cookie” information, the type of browser
            and/or device you’re using to access our Platform, information about
            your mobile device, including a unique identifier for your device
            and purchase history; which we sometimes aggregate with similar
            information from other customers to create features such as
            best-selling products, products you viewed or searched for, products
            you may like. We may also use browser data such as cookies, flash
            cookies, or similar data on certain parts of our Platform. We may
            use software tools such as JavaScript to measure and collect session
            information, including page response times, download errors, length
            of visits to certain pages, page interaction information (such as
            scrolling, clicks, and mouse-overs), and methods used to browse away
            from the page. We use this information for internal analysis and to
            provide you with location-based services, such as advertising,
            search results, and other personalized content, to give you the best
            possible shopping experience on our Platform.
          </p>
        </div>
        {/* <div>
          <b>3) Information from other sources</b>
          <p>
            We may receive information about you from third parties, such as
            social media services, commercially available sources, and business
            partners. If you access our Platform through a social media service
            or connect a service on our Platform to a social media service, the
            information we collect may include but is not limited to your user
            name, profile picture, email address, friends list and any other
            information associated with that social media service, which the
            social media service has the right to share with us and any other
            information or content you have made public in connection with that
            social media service. Whenever you access the Platform or contact us
            through social media services, you authorize us to collect, store,
            analyze and use such information in accordance with this Policy.
          </p>
        </div> */}
      </>
    ),
  },
  {
    id: 3,
    title: "How do we use cookies?",
    content: (
      <>
        <div>
          A cookie is a small file that we, after obtaining your permission,
          transfer to your computer’s hard drive through your web browser. This
          file helps us recognize your browser and respond to you as an
          individual, as well as provide personalized features and
          advertisements based on your needs, likes, dislikes and behavior on
          our Platform.
        </div>
        <div>
          You can choose to accept or decline cookies. The help menu on most
          browsers will tell you how to prevent the browser from accepting new
          cookies and deleting / disabling existing cookies. However, disabling
          / deleting our cookies could prevent you from taking full advantage of
          our Platform’s various features.
        </div>
      </>
    ),
  },
  {
    id: 4,
    title: "Do we share the information we receive?",
    content: (
      <>
        <div>
          Respecting customers’ privacy is not only an important part of our
          business but one of the core philosophies of our organization. We
          never have and never will commercially exploit such information by
          selling it to third parties. We share customer information only as
          described below, and in no other manner:
        </div>
        <div>
          1) Third-party service providers <br /> We employ other companies and
          individuals to perform some functions on our behalf. These functions
          include but are not limited to fulfilling orders, delivering packages,
          analyzing customer data, providing marketing assistance, providing
          search results and links, and processing payments. For optimum
          fulfillment of these functions, they have access only to such customer
          information as is needed to perform their functions, and are
          contractually bound to not use it for any other purpose.
        </div>
        <div>
          2) Compliance with law <br /> We may be required to share customer
          information with government authorities and agencies for the purposes
          of verification of identity or for prevention, detection or
          investigation, including of cyber incidents, prosecution, and
          punishment of offenses. Further, we may release account and other
          personal information when we believe release is appropriate to enforce
          or apply our Terms of Use and other agreements; or protect the rights,
          property or safety of The Souled Store, our users or others. This
          includes exchanging information with other companies, organizations,
          government or regulatory authorities for fraud protection and credit
          risk reduction.
        </div>
        <div>
          3) With your consent <br /> Other than as set out above, you will
          receive notice when information about you might go to third parties
          and you will have the option to choose whether or not you’d like such
          information to be shared.
        </div>
      </>
    ),
  },
  {
    id: 5,
    title:
      "Who should I contact with my grievances regarding this Privacy Policy?",
    content: (
      <>
        <div>
          If you have any questions or feedback regarding this Policy, you may
          contact us using the information below:
        </div>
        <div>
          <p>Name: KRISTIVE</p>
          <p>Contact Number: 8160192573</p>
          <p>Email: support@KRISTIVE.com</p>
          <p>Timing: Monday to Saturday- 10 am to 6 pm</p>
        </div>
      </>
    ),
  },
];
